import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import "./assets/css/global.css";

/* ==== MONITORING ==== */
import { initLogRocket, identifyLogRocket, logRocketPiniaPlugin } from "./utils/logrocket";

initLogRocket();
identifyLogRocket();

/* ==== IONIC VUE ==== */
import { IonicVue } from "@ionic/vue";

/* ==== IONIC CSS ==== */
import "@ionic/vue/css/core.css";
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";

/* ==== REGISTER SERVICE WORKER ==== */
import "./registerServiceWorker";

/* ==== CREATE APP ==== */
const app = createApp(App);

const pinia = createPinia();
pinia.use(logRocketPiniaPlugin);

app.use(IonicVue);
app.use(pinia);
app.use(router);

router.isReady().then(() => {
  app.mount("#app");
});
